export default "__VITE_ASSET__DFZMP6oh__"